<template>
  <vue-draggable-resizable
    v-if="!hideParent"
    :parent="true"
    :x="position.left"
    :y="position.top"
    :w="position.width"
    :h="position.height"
    :draggable="!isSavingLayout && !isWidgetLocked"
    :resizable="!isSavingLayout && !isWidgetLocked"
    :grid="gridScale"
    :snap="isSnapActive"
    :active="isWidgetSelected"
    :z="(isWidgetSelected && keepZIndexUp ? 1000 : 100) + widget.position[rotation].zIndex"
    :onDragStart="(x, y) => onChangePosition(true, x, y)"
    :onResizeStart="() => onChangePosition(false)"
    @dragstop="onWidgetDrag"
    @resizestop="onWidgetResize"
    @activated="() => onSelected(widget)"
    @deactivated="() => (keepZIndexUp = false)"
    @refLineParams="getRefLineParams"
  >
    <div class="widget-item" :style="style">
      <PlaylistPlayer
        :style="playlistStyle"
        :playlist="{
          ...widget.object,
          imageMode: widget.object.imageMode || widget.position.imageMode,
          playlistId: widget.playlist_id,
          wid: widget.object.wid,
        }"
        :playSlider="false"
      />
    </div>
  </vue-draggable-resizable>
</template>

<script>
  import VueDraggableResizable from '@/components/common/VueDraggableResizable.vue';

  import playerMixins from '@/models/player';
  import { simpleTypeMixin } from '@/helpers';

  import draggableWidget from '@/components/layoutDesigner/mixins/draggableWidget';
  import PlaylistPlayer from '@/components/player/PlaylistPlayer.vue';

  export default {
    name: 'PlaylistWidget',

    components: {
      VueDraggableResizable,
      PlaylistPlayer,
    },

    mixins: [playerMixins, simpleTypeMixin, draggableWidget],

    props: {
      widget: {
        type: Object,
      },
    },

    computed: {
      style() {
        return {
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
        };
      },

      playlistStyle() {
        return { position: 'relative', zoom: this.scaleLayoutValue(1) };
      },

      position() {
        return this.getPosition(this.widget);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
